export const fixedHeader = () => {
  const header = document.querySelector(".js-header");
  if (!header) return;

  const homeRoot = document.querySelector(".js-front-page");

  // 下層ページ：最初から fixed
  if (!homeRoot) {
    header.classList.add("is-fixed");
    return;
  }

  const mvSection = document.querySelector(".js-mv");
  if (!mvSection) {
    header.classList.add("is-fixed");
    return;
  }

  let mvHeight = mvSection.offsetHeight;

  const thresholdY = () => mvSection.offsetTop + mvSection.offsetHeight;

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop >= thresholdY()) {
      header.classList.add("is-fixed");
      header.style.top = "";
    } else {
      header.classList.remove("is-fixed");
      header.style.top = `${mvHeight}px`;
    }
  };

  const updateLayout = () => {
    mvHeight = mvSection.offsetHeight;
    handleScroll();
  };

  updateLayout();
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", updateLayout);
};
